
import { DialogController } from 'aurelia-dialog';
import { ContractLine } from '../../services/customer-info-store';
import { UsageIntervalEnum, UsageReport, UsageReportItemType, UsageReportPeriod, UsageStore } from '../../services/usage-store';
import { autoinject, bindable } from 'aurelia-framework';
import { renderLineChart } from '../../services/licensing-contract-line-chart-service';
import { renderBarChart } from '../../services/licensing-contract-bar-chart-service';

export interface ContractDetailsParameters {
    contractLine: ContractLine;
    organizationId: string;
}

export enum ViewType {
    LineChart = "LineChart",
    BarChart = "BarChart",
    BarChartDay = "BarChartDay",
}

@autoinject
export class ContractDetails {
    @bindable public ViewType = ViewType;

    public isLoading: boolean = true;
    public currentViewType: ViewType = ViewType.LineChart;
    public contractName: string = "License Contract Report"

    private contractDetailsParameters: ContractDetailsParameters;

    constructor(private controller: DialogController, private usageStore: UsageStore) { }

    activate(contractDetailsParameters: ContractDetailsParameters) {
        this.contractDetailsParameters = contractDetailsParameters;
        this.contractName = contractDetailsParameters.contractLine.name;

        this.showLineChart();
    }

    attached() {

        // If we are showing the chart only, remove the margins from the dialog container as we might have limited space
        const params = new URLSearchParams(window.location.search);
            if (params.get('chartonly') === 'true') {
                const style = document.createElement('style');
                style.textContent = `
          ux-dialog-container > div {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }
        `;
            document.head.appendChild(style);
        }
    }

    showLineChart() {
        console.log("Show line chart!");

        this.isLoading = true;

        this.usageStore.retrieveBundleReport(this.contractDetailsParameters.organizationId, this.contractDetailsParameters.contractLine).then((result) => {
            const graphContainer = document.querySelector('.graph-container') as HTMLElement;
            const graphLegendContainer = document.querySelector('.graph-legend-container') as HTMLElement;

            console.log('Render graph', result);

            renderLineChart(result, graphContainer, graphLegendContainer);

            this.isLoading = false;
            this.currentViewType = ViewType.LineChart;

            console.log('done');
        });
    }

    showBarChart() {
        console.log("Show bar chart!");

        this.isLoading = true;

        this.usageStore.retrieveBundleReport(this.contractDetailsParameters.organizationId, this.contractDetailsParameters.contractLine).then((result) => {
            const graphContainer = document.querySelector('.graph-container') as HTMLElement;
            const graphLegendContainer = document.querySelector('.graph-legend-container') as HTMLElement;

            const report: UsageReport = {
                usageReportPeriod: result.usageReportPeriod,
                reportItems: result.reportItems.filter(x => x.type === UsageReportItemType.ActualPrevious || x.type === UsageReportItemType.Actual),
            };

            console.log('Render graph');

            renderBarChart(report, graphContainer, graphLegendContainer, this.showBarChartDay.bind(this));

            this.isLoading = false;
            this.currentViewType = ViewType.BarChart;

            console.log('done');
        });
    }

    showBarChartDay(startDate: string, endDate: string) {
        this.isLoading = true;

        const reportPeriod: UsageReportPeriod = {
            startDate: startDate,
            endDate: endDate,
            interval: UsageIntervalEnum.Day,
        };

        this.usageStore.retrieveUsage(this.contractDetailsParameters.organizationId, this.contractDetailsParameters.contractLine.contractLineId, reportPeriod).then((result) => {

            result.reportItems.forEach(item => {
                item.xAxisValue = new Date(item.startDate);
                item.type = UsageReportItemType.Actual
            });

            const graphContainer = document.querySelector('.graph-container') as HTMLElement;
            const graphLegendContainer = document.querySelector('.graph-legend-container') as HTMLElement;

            renderBarChart(result, graphContainer, graphLegendContainer, this.showBarChart.bind(this));

            this.isLoading = false;
            this.currentViewType = ViewType.BarChartDay;
        });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/components/licensing-overview/license-contract-details.ts